import client from './client';
import type { Candidate, Trade, Holding, EnrichedHolding } from '../types';

/**
 * 交易 API 封装
 */

/** 候选股响应元数据 */
export interface CandidateResponse {
  date: string;
  source: string;
  candidates: Candidate[];
}

/** 候选股日期列表 */
export async function fetchCandidateDates(): Promise<{ date: string; count: number }[]> {
  const res = await client.get('/candidates/dates');
  return res.data;
}

/** 获取买入候选（自动回退到最新日期） */
export async function fetchCandidates(date?: string): Promise<CandidateResponse> {
  const res = await client.get('/candidates', { params: date ? { date } : {} });
  // 兼容旧格式（数组）和新格式（对象含 date/source/candidates）
  if (Array.isArray(res.data)) {
    return { date: date || '', source: '历史数据', candidates: res.data };
  }
  return res.data as CandidateResponse;
}

/** 虚拟买入 */
export async function buy(code: string, price: number, quantity: number): Promise<Trade> {
  const res = await client.post('/trades/buy', { code, price, quantity });
  return res.data;
}

/** 手动卖出 */
export async function sell(holdingId: number, price?: number, quantity?: number): Promise<Trade> {
  const res = await client.post('/trades/sell', { holdingId, price, quantity });
  return res.data;
}

/** 获取持仓列表 */
export async function fetchHoldings(status: 'held' | 'sold' | 'all' = 'held'): Promise<Holding[]> {
  const res = await client.get('/portfolio', { params: { status } });
  return res.data;
}

/** 获取持仓增强数据（入选价/20日最低/买卖触发价/买入后高低/今日收盘盈亏） */
export async function fetchEnrichedHoldings(): Promise<EnrichedHolding[]> {
  const res = await client.get('/portfolio/enriched');
  return res.data;
}
